<template lang="pug">
.content-wrap
  .content-top
    .con
      div
        //- 1. Hero
        .section
          img(src="/new/img/aboutus/about-us.webp" alt="Every Win is EpicWin")

        //- 2. Our Promise
        .section
          img(src="/new/img/aboutus/our-promise.webp" alt="Our Promise")

        //- 3. EpicWin Through the Years
        section.tl-section(ref="tlSection")
          .tl-header
            p.tl-eyebrow Our Journey
            h2.tl-heading EpicWin Through The Years
            .tl-header-bar

          .tl-track
            .tl-item(
              v-for="item in timelineItems"
              :key="item.img"
            )
              .tl-node
              .tl-card.tl-card-img
                img(:src="item.img" :alt="item.alt")

        //- Section separator
        .timeline-after
          .glow-line

          .orbs
            .orb(
              v-for="n in 7"
              :key="n"
            )

          .glow-center

        //- 4. Our Story, Mission & Why We Exist
        .section
          img(src="/new/img/aboutus/our-story-full.webp" alt="Our Story, Our Mission and Why We Exist")

        //- 5. Gaming License
        .section.pointer
          a(
            href="https://igamingtips.org/certification-verified/"
            target="_blank"
            rel="noopener noreferrer"
            style="display:block;line-height:0;"
          )
            img(src="/new/img/aboutus/gaming-license.webp" alt="Gaming License")
      footerInfo
</template>
<script>
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
  name: 'AboutUs',
  components:{
		footerInfo
	},
  data() {
    return {
      tlItems: [],
      tlObserver: null,
      rafId: null,

      timelineItems: [
        {
          img: '/new/img/aboutus/2026.webp',
          alt: '2026 — Every Win Is EpicWin'
        },
        {
          img: '/new/img/aboutus/2025-2024.webp',
          alt: '2025–2024 — Building Our VIP Community'
        },
        {
          img: '/new/img/aboutus/2023.webp',
          alt: '2023 — Growing Beyond Gaming'
        },
        {
          img: '/new/img/aboutus/2022.webp',
          alt: '2022 — Creating The Epic Community'
        },
        {
          img: '/new/img/aboutus/2021.webp',
          alt: '2021 — Entertainment Beyond Gaming'
        },
        {
          img: '/new/img/aboutus/2020.webp',
          alt: '2020 — The Beginning'
        }
      ]
    };
  },
  created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/aboutUs`);
		// this.getSeo("contactUs")
	},

  mounted() {
    this.$nextTick(() => {
      this.initTimelineObserver();
      this.createParticles();

      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });

      this.updateActiveCard();
    });
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    if (this.tlObserver) {
      this.tlObserver.disconnect();
      this.tlObserver = null;
    }
  },

  methods: {
    initTimelineObserver() {
      this.tlItems = Array.from(this.$el.querySelectorAll('.tl-item'));

      this.tlObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            this.tlObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.18
      });

      this.tlItems.forEach(el => {
        this.tlObserver.observe(el);
      });
    },

    updateActiveCard() {
      const mid = window.innerHeight / 2;
      let closest = null;
      let minDist = Infinity;

      this.tlItems.forEach(item => {
        if (!item.classList.contains('visible')) return;

        const rect = item.getBoundingClientRect();
        const dist = Math.abs((rect.top + rect.height / 2) - mid);

        if (dist < minDist) {
          minDist = dist;
          closest = item;
        }
      });

      this.tlItems.forEach(item => {
        if (!item.classList.contains('visible')) return;

        item.classList.remove('tl-active', 'tl-dimmed');

        if (item === closest) {
          item.classList.add('tl-active');
        } else {
          item.classList.add('tl-dimmed');
        }
      });
    },

    handleScroll() {
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        this.updateActiveCard();
        this.rafId = null;
      });
    },

    createParticles() {
      const tlSection = this.$refs.tlSection;

      if (!tlSection) return;

      for (let i = 0; i < 30; i++) {
        const p = document.createElement('div');

        p.className = 'tl-particle';

        const sz = Math.random() * 2.5 + 0.8;
        const gold = Math.random() > 0.45;
        const col = gold ? '#c8a84b' : '#a855f7';

        p.style.cssText = [
          `left:${Math.random() * 100}%`,
          `bottom:${Math.random() * 100}%`,
          `width:${sz}px`,
          `height:${sz}px`,
          `background:${col}`,
          `box-shadow:0 0 ${sz * 4}px ${col}`,
          `animation-duration:${(Math.random() * 7 + 5).toFixed(1)}s`,
          `animation-delay:${(Math.random() * 9).toFixed(1)}s`
        ].join(';');

        tlSection.appendChild(p);
      }
    }
  }
};
</script>
<style lang="scss" scoped>

/* body {
  background: #07000f;
  font-family: 'Segoe UI', sans-serif;
  padding: 0 14px;
} */

.section {
  width: 100%;
  line-height: 0;
  display: block;
}

.section img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
}

/* ── Footer ── */
footer {
  background: #07000f;
  padding: 52px 24px 36px;
  text-align: center;
}

.footer-logo {
  margin-bottom: 28px;
}

.footer-logo img {
  height: 44px;
  width: auto;
}

.footer-block {
  margin-bottom: 36px;
}

.footer-label {
  color: rgba(255, 255, 255, 0.4);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 14px;
}

.icon-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.icon-row img {
  height: 30px;
  width: auto;
  display: block;
}

.icon-row.lg img {
  height: 36px;
}

.icon-row.sm img {
  height: 26px;
}

.divider {
  width: 48px;
  height: 1px;
  background: rgba(255, 255, 255, 0.12);
  margin: 0 auto 36px;
}

.footer-copy {
  color: rgba(255, 255, 255, 0.25);
  font-size: 11px;
  line-height: 1.6;
  margin-top: 28px;
}

.icon-row a {
  display: inline-flex;
  text-decoration: none;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.icon-row a:hover {
  transform: scale(1.12);
  opacity: 0.85;
}

.trustpilot-wrap {
  margin-top: 16px;
  display: inline-block;
}

.trustpilot-wrap img {
  height: 54px;
  width: auto;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.trustpilot-wrap:hover img {
  transform: scale(1.08);
  opacity: 0.85;
}

.cert-link {
  display: block;
  text-decoration: none;
}

/* ── Timeline rebuilt ── */
.tl-section {
  background: #07000f;
  padding: 64px 0 48px;
}

.tl-header {
  text-align: center;
  margin-bottom: 52px;
}

.tl-eyebrow {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #c8a84b;
  margin-bottom: 8px;
}

.tl-heading {
  font-size: clamp(20px, 5vw, 34px);
  font-weight: 900;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 0 0 40px rgba(168, 85, 247, 0.5);
  margin-bottom: 16px;
  line-height: 1.2;
}

.tl-header-bar {
  width: 56px;
  height: 2px;
  background: linear-gradient(90deg, #a855f7, #c8a84b);
  margin: 0 auto;
  border-radius: 2px;
}

.tl-track {
  max-width: 100%;
  position: relative;
  padding-left: 26px;
}

.tl-track::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background: linear-gradient(to bottom, #a855f7 80%, rgba(168, 85, 247, 0.1));
}

.tl-item {
  position: relative;
  margin-bottom: 24px;
  opacity: 0;
  transform: translateY(40px) scale(0.92);
  transition: opacity 0.55s ease, transform 0.55s cubic-bezier(0.34, 1.46, 0.64, 1);
}

.tl-item.visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.tl-item.visible .tl-card {
  animation: neon-on 0.95s ease-out forwards;
}

.tl-item.visible .tl-year {
  animation: gold-glow 1s ease-out 0.2s both;
}

.tl-item.visible .tl-node {
  animation: dot-flash 0.5s ease-out forwards,
            node-pulse 2.5s ease-out 0.7s infinite;
}

@keyframes neon-on {
  0%   { border-color: transparent; box-shadow: none; }
  20%  { border-color: #c084fc;
        box-shadow: 0 0 10px #a855f7,
                    0 0 25px rgba(168,85,247,0.7),
                    0 0 55px rgba(168,85,247,0.35),
                    inset 0 0 18px rgba(168,85,247,0.08); }
  50%  { border-color: #d8b4fe;
        box-shadow: 0 0 20px #a855f7,
                    0 0 45px rgba(168,85,247,0.5),
                    0 0 90px rgba(168,85,247,0.2); }
  75%  { box-shadow: 0 0 10px rgba(168,85,247,0.3),
                    0 0 22px rgba(168,85,247,0.15);
        border-color: rgba(168,85,247,0.5); }
  100% { box-shadow: 0 0 6px rgba(168,85,247,0.12);
        border-color: rgba(168,85,247,0.32); }
}

@keyframes gold-glow {
  0%   { text-shadow: none; }
  35%  { text-shadow: 0 0 8px #c8a84b,
                      0 0 20px #c8a84b,
                      0 0 50px rgba(200,168,75,0.8),
                      0 0 90px rgba(200,168,75,0.35); }
  65%  { text-shadow: 0 0 12px #c8a84b,
                      0 0 28px rgba(200,168,75,0.45); }
  100% { text-shadow: 0 0 6px rgba(200,168,75,0.28); }
}

@keyframes dot-flash {
  0%   { background: rgba(168,85,247,0.15); box-shadow: none; }
  40%  { background: #e9d5ff;
        box-shadow: 0 0 0 6px rgba(168,85,247,0.5), 0 0 22px #a855f7; }
  100% { background: #a855f7;
        box-shadow: 0 0 0 4px rgba(168,85,247,0.2); }
}

@keyframes node-pulse {
  0%   { box-shadow: 0 0 0 0    rgba(168, 85, 247, 0.7); }
  70%  { box-shadow: 0 0 0 12px rgba(168, 85, 247, 0);   }
  100% { box-shadow: 0 0 0 0    rgba(168, 85, 247, 0);   }
}

.tl-node {
  position: absolute;
  left: -26px;
  top: 28px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(168, 85, 247, 0.15);
}

.tl-card {
  background: linear-gradient(135deg, rgba(100, 10, 150, 0.4) 0%, rgba(25, 0, 55, 0.75) 100%);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 22px 26px;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.35s ease, border-color 0.35s ease, transform 0.35s ease, filter 0.35s ease, opacity 0.35s ease;
}

.tl-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, #a855f7, #c8a84b, #a855f7);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tl-item.visible .tl-card:hover {
  transform: scale(1.015);
  box-shadow: 0 0 18px rgba(168, 85, 247, 0.35),
              0 0 40px rgba(168, 85, 247, 0.18);
  border-color: rgba(168, 85, 247, 0.6);
}

.tl-item.visible .tl-card:hover::before {
  opacity: 1;
}

.tl-year {
  font-size: 44px;
  font-weight: 900;
  color: #c8a84b;
  line-height: 1;
  margin-bottom: 6px;
  letter-spacing: -1px;
  white-space: nowrap;
}

.tl-card-title {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 1.4px;
  margin-bottom: 12px;
}

.tl-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tl-list li {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.68);
  padding: 3px 0 3px 18px;
  position: relative;
  line-height: 1.5;
}

.tl-list li::before {
  content: '▸';
  position: absolute;
  left: 0;
  color: #c8a84b;
  font-size: 10px;
  top: 5px;
}

/* ── Timeline glow strip ── */
.timeline-after {
  background: #07000f;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 0 36px;
  gap: 20px;
  overflow: hidden;
  position: relative;
}

.glow-line {
  width: 60%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #c8a84b 30%, #a855f7 60%, #c8a84b 80%, transparent);
  animation: glow-pulse 3s ease-in-out infinite;
  position: relative;
}

.glow-line::before {
  content: '';
  position: absolute;
  inset: -3px 10%;
  background: inherit;
  filter: blur(6px);
  opacity: 0.6;
}

@keyframes glow-pulse {
  0%, 100% { opacity: 0.5; transform: scaleX(0.7); }
  50%       { opacity: 1;   transform: scaleX(1); }
}

.orbs {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.orb {
  border-radius: 50%;
  animation: orb-float 2.4s ease-in-out infinite;
}

.orb:nth-child(1) { width: 7px;  height: 7px;  background: #c8a84b; animation-delay: 0s; }
.orb:nth-child(2) { width: 5px;  height: 5px;  background: #fff;    animation-delay: 0.25s; opacity: 0.5; }
.orb:nth-child(3) { width: 12px; height: 12px; background: #a855f7; animation-delay: 0.5s; box-shadow: 0 0 10px #a855f7; }
.orb:nth-child(4) { width: 16px; height: 16px; background: #c8a84b; animation-delay: 0.75s; box-shadow: 0 0 14px #c8a84b; }
.orb:nth-child(5) { width: 12px; height: 12px; background: #a855f7; animation-delay: 1s;    box-shadow: 0 0 10px #a855f7; }
.orb:nth-child(6) { width: 5px;  height: 5px;  background: #fff;    animation-delay: 1.25s; opacity: 0.5; }
.orb:nth-child(7) { width: 7px;  height: 7px;  background: #c8a84b; animation-delay: 1.5s; }

@keyframes orb-float {
  0%, 100% { transform: translateY(0);    opacity: 0.7; }
  50%       { transform: translateY(-9px); opacity: 1; }
}

.glow-center {
  width: 200px;
  height: 40px;
  background: radial-gradient(ellipse at center, rgba(168, 85, 247, 0.25) 0%, transparent 70%);
  animation: center-pulse 3s ease-in-out infinite;
}

@keyframes center-pulse {
  0%, 100% { opacity: 0.4; transform: scaleX(0.8); }
  50%       { opacity: 1;   transform: scaleX(1.2); }
}

.tl-card-img {
  padding: 0;
}

.tl-card-img img {
  width: 100%;
  display: block;
  border-radius: 11px;
}

/* ── Aurora background on timeline section ── */
.tl-section {
  position: relative;
  overflow: hidden;
}

.tl-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 70% 40% at 90% 10%, rgba(168,85,247,0.13) 0%, transparent 70%),
    radial-gradient(ellipse 55% 30% at 10% 80%, rgba(200,168,75,0.08) 0%, transparent 70%),
    radial-gradient(ellipse 40% 25% at 50% 50%, rgba(168,85,247,0.05) 0%, transparent 70%);
  animation: aurora-drift 10s ease-in-out infinite alternate;
  pointer-events: none;
  z-index: 0;
}

@keyframes aurora-drift {
  0%   { opacity: 0.5; transform: scale(1)    rotate(-1.5deg); }
  100% { opacity: 1;   transform: scale(1.10) rotate(1.5deg); }
}

.tl-header,
.tl-track {
  position: relative;
  z-index: 1;
}

/* ── Floating star particles ── */
.tl-particle {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  animation: tl-particle-rise linear infinite;
  opacity: 0;
  z-index: 0;
}

@keyframes tl-particle-rise {
  0%   { opacity: 0;   transform: translateY(0)      scale(0.4); }
  12%  { opacity: 0.9; }
  88%  { opacity: 0.3; }
  100% { opacity: 0;   transform: translateY(-100px) scale(1.5); }
}

/* ── Active card (most centred in viewport) ── */
.tl-item.tl-active .tl-card {
  border-color: rgba(200,168,75,0.85) !important;
  box-shadow: 0 0 20px rgba(200,168,75,0.35),
              0 0 50px rgba(168,85,247,0.4),
              0 0 90px rgba(168,85,247,0.18) !important;
  transform: scale(1.025);
}

.tl-item.tl-active .tl-card::before {
  opacity: 1 !important;
}

.tl-item.tl-active .tl-node {
  background: #c8a84b !important;
  animation: node-gold-pulse 1.5s ease-in-out infinite !important;
}

@keyframes node-gold-pulse {
  0%, 100% { box-shadow: 0 0 0 0    rgba(200,168,75,0.85), 0 0 16px #c8a84b; }
  55%       { box-shadow: 0 0 0 14px rgba(200,168,75,0),    0 0 30px #c8a84b; }
}

/* ── Dimmed cards (visible but not the active one) ── */
.tl-item.tl-dimmed .tl-card {
  filter: brightness(0.52);
  transform: scale(0.97);
}

/* ── Scan line that sweeps down the active card image ── */
.tl-card-img::after {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg,
    transparent       0%,
    rgba(200,168,75,0.7) 30%,
    rgba(255,255,255,1)  50%,
    rgba(168,85,247,0.7) 70%,
    transparent       100%);
  top: -3px;
  pointer-events: none;
  opacity: 0;
  filter: blur(1px);
}

.tl-item.tl-active .tl-card-img::after {
  animation: scan-pass 3s ease-in-out 0.5s infinite;
}

@keyframes scan-pass {
  0%   { top: -3px;        opacity: 0; }
  5%   {                   opacity: 1; }
  95%  {                   opacity: 0.75; }
  100% { top: calc(100%);  opacity: 0; }
}

/* ── Timeline section heading entrance ── */
.tl-header {
  animation: header-drop 0.7s cubic-bezier(0.34, 1.46, 0.64, 1) both;
}

@keyframes header-drop {
  from { opacity: 0; transform: translateY(-24px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>